import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Sidebar } from "../../partials/Sidebar";
import { Navbar } from "../../partials/Navbar";


const  Account= (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const userDetails = useSelector((state) => state.auth.user);
  const isAuthorized = useSelector((state) => state.auth.authenticated);
  return (
    <>
      <div>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <Navbar sidebarOpen={sidebarOpen}  isAuthorized={isAuthorized} userDetails={userDetails}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">
              Account Details
            </h1>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            {/* content */}
            <div className="py-4">
              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="bg-white shadow p-4 overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <div className="flex items-center gap-6 mb-5">
                        <div>
                          {userDetails.avatar ? (
                            <img
                              src={userDetails.avatar}
                              className="h-16 w-16 rounded-full border"
                              alt="avatar"
                            />
                          ) : (
                            <svg
                              className="h-16 w-16 border text-gray-300 rounded-full bg-gray-400"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          )}
                        </div>
                        <div>
                          <div className="mb-2">{userDetails.username}</div>
                          <div className="">{userDetails.phoneNumber}</div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 mt-6 w-full ">
                        <div className="mb-4">
                          <span className="font-semibold">Full Name:</span>{" "}
                          {userDetails.firstName + " " + userDetails.lastName}
                        </div>

                        <div className="mb-4">
                          <span className="font-semibold">Email:</span>{" "}
                          {userDetails.email}
                        </div>

                        <div className="mb-4">
                          <span className="font-semibold">Role:</span>{" "}
                          {userDetails.role}
                        </div>

                        <div className="mb-4">
                          <span className="font-semibold">Team:</span>{" "}
                          {userDetails.team}
                        </div>

                        <div className="mb-4">
                          <span className="font-semibold">Location:</span>{" "}
                          {userDetails.location}
                        </div>

                        <div className="mb-4">
                          <span className="font-semibold">Operator:</span>{" "}
                          {userDetails.operator}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /End content */}
          </div>
        </Navbar>
      </div>
    </>
  );
}


export default Account;
